import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ConsultTab from "./consultTab";
import Notes from "./notes";
import EditIcon from "../assets/editIcon.svg";
import Checkbox from '@material-ui/core/Checkbox';
import Loader from "./subComponents/loader"
import ErrorModal from "./subComponents/errorModal";
import MainPageStyle from "../styles/mainPageStyle";
import { AddProductInfo as addProductInfo, } from '../constants/visits.constant';
import { APIData as apiData } from '../constants/common.constant';


function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
class HistoryView extends React.Component {

    componentDidMount() {
        let { GetPatientInfo, ResetPatientInfo, GetProductInfo, match, GetConsultQuestions } = this.props;
        ResetPatientInfo && ResetPatientInfo();
        let OrderId = match && match.params && match.params.orderId;
        let UserId = match && match.params && match.params.userId;
        GetPatientInfo && GetPatientInfo({ OrderId, UserId });
        GetProductInfo && GetProductInfo({ OrderId, UserId });
        GetConsultQuestions && GetConsultQuestions({ OrderId, UserId });
    }

    changeValueToString = (data) => {
        let response = "";
        data && data.length !== 0 && data.forEach((value, index) => {
            if (index === 0) {
                response = value;
            } else {
                response = response + ", " + value;
            }
        })
        if (!response) {
            response = "NONE"
        }
        return response;
    }

    handleChange = (event, index) => {
        let { SetSelectedTab } = this.props;
        SetSelectedTab && SetSelectedTab(index)
    }
    checkDisabled = (index) => {
        let { productInfo: { Product = [] } = {} } = this.props;
        if (Product[index].checked) {
            for (let i = 0; i < Product.length; i++) {
                if (index !== i && Product[i].checked) {
                    return false;
                }
            }
            return true;
        }
    }
    genrateData = (data = {}) => {
        let obj = { OrderDate: [], OrderId: [], ProductTitle: [], editIcon: [], Qty: [], OrderType: [], Status: [] };
        let { classes, notEditIcon = true } = this.props;
        if (data.OrderDate || data.OrderDate === 0) {
            obj.OrderDate.push(<div id="consult-order-date-row" title={data.OrderDate} className={`${classes.tableRow}`}>{data.OrderDate}</div>);
        } else {
            obj.OrderDate.push(null);
        }

        if (data.OrderId || data.OrderId === 0) {
            obj.OrderId.push(<div id="consult-order-id-row" title={data.OrderId} className={`${classes.tableRow} ${classes.tableRowBold}`}>{data.OrderId}</div>);
        } else {
            obj.OrderId.push(null);
        }
        let { Product = [] } = data;
        for (let i = 0; i < Product.length; i++) {
            let isCheckboxDisabled = this.checkDisabled(i);
            obj.ProductTitle.push(
                <div title={Product[i].ProductTitle} className={`${classes.tableRow}`}>
                    {Product.length > 1 ? <Checkbox
                        title=""
                        id={`checkbox${i}`}
                        disabled={isCheckboxDisabled}
                        className={(isCheckboxDisabled || !Product[i].checked) ? classes.disabledCheckbox : classes.checkbox}
                        checked={Product[i].checked}
                        onChange={(e) => this.handleChange(e, i)}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    /> : null}
                    <div className={classes.tableRowEllipsis}>{Product[i].ProductTitle}</div>
                </div>);
            (!notEditIcon && obj.editIcon.push(<div id="consult-edit-row" className={classes.imageWrapper}><img alt="" onClick={_ => this.ToggleModal(true, i)} id="changeProductIcon" title={"Edit Product"} className={classes.editIcon} src={EditIcon} /></div>))
            obj.Qty.push(<div title={Product[i].Qty} id="consult-qty-row" className={`${classes.tableRow} ${classes.tableCenter}`}>{Product[i].Qty}</div>);
            obj.OrderType.push(<div title={Product[i].OrderType} id="consult-order-type-row" className={`${classes.tableRow} ${classes.tableCenter}`}>{Product[i].OrderType}</div>);
            obj.Status.push(<div title={Product[i].Status} id="consult-order-status-row" className={`${classes.tableRow} ${classes.tableCenter}`}>{Product[i].Status}</div>);
        }
        return obj;
    }

    render() {
        let {
            classes,
            data,
            selectedPatientInfo = {},
            selectedTab,
            handleRouteChange,
            selectedCardData,
            title,
            routePath,
            match = {},
            notes,
            loading,
            notEditIcon = true,
            productInfo,
            errorModalOpen,
            ToggleErrorModal,
            ...restProps
        } = this.props;
        const orderId = (() => {
            try {
                return this.props.match.params.orderId;
            } catch (e) {
                return 0;
            }
        })();
        let tableRows = this.genrateData(productInfo);
        return (<div className={classes.wrapper} data-view="history-view-component-wrapper">
            <div className={classes.contentWrapper} data-view="patientDemographics">
                <div className={`${classes.headerSection}`}>
                    <div className={classes.demographicsHistory}>
                        <div id="main-page-patient-name" className={classes.patientName}>{selectedPatientInfo.FirstName} {selectedPatientInfo.LastName}</div>
                        <div className={classes.patientDOBContainer}>
                            <div id="main-page-patient-region" className={classes.patientRegion}>{selectedPatientInfo.City ? selectedPatientInfo.City + ", " : ""}{selectedPatientInfo.State}</div>
                            <div id="main-page-patient-dob" className={classes.patientRegion}>DOB: {selectedPatientInfo.DOB ? selectedPatientInfo.DOB : ""}</div>
                        </div>
                        <div id="main-page-patient-gender" className={classes.patientGender}>Gender Identity: {selectedPatientInfo.Gender}</div>
                    </div>
                    <div className={classes.statsWrapper}>
                        <div className={classes.stats}>
                            <div className={classes.statsDetailsHistory}>
                                <div className={classes.textCenterHistory}>
                                    <div id="main-page-patient-weight-value" className={classes.patientStats}>{selectedPatientInfo.Weight ? selectedPatientInfo.Weight + " lb" : "-"}</div>
                                    <div id="main-page-patient-weight-label" className={classes.patientStatsTitle}>Weight</div>
                                </div>
                                <div className={classes.textCenterHistory}>
                                    <div id="main-page-patient-height-value" className={classes.patientStats}>{selectedPatientInfo.Height ? selectedPatientInfo.Height + '"' : "-"}</div>
                                    <div id="main-page-patient-height-label" className={classes.patientStatsTitle}>Height</div>
                                </div>
                                <div className={classes.textCenterHistory}>
                                    <div id="main-page-patient-bmi-value" className={classes.patientStats}>{selectedPatientInfo.BMI ? selectedPatientInfo.BMI : "-"}</div>
                                    <div id="main-page-patient-bmi-label" className={classes.patientStatsTitle}>BMI</div>
                                </div>
                                <div className={classes.textCenterHistory}>
                                    <div id="main-page-patient-age-value" className={classes.patientStats}>{selectedPatientInfo.Age ? selectedPatientInfo.Age : "-"}</div>
                                    <div id="main-page-patient-age-label" className={classes.patientStatsTitle}>Age</div>
                                </div>
                            </div>
                        </div>

                        <div className={classes.medWrapper}>
                            <div id="main-page-patient-sf-medication-wrapper" className={classes.storefrontMedication}>
                                <span id="main-page-patient-sf-medication-label" className={classes.medBold}>Storefront Medications:</span> {this.changeValueToString(selectedPatientInfo.StorefrontMedications)}
                            </div>
                            <div id="main-page-patient-personal-medication-wrapper" className={`${classes.storefrontMedication} ${classes.storefrontMedicationMargin}`}>
                                <span id="main-page-patient-personal-medication-label" className={classes.medBold}>Personal Medications:</span> {this.changeValueToString(selectedPatientInfo.PersonalMedicatoins)}
                            </div>
                            <div id="main-page-patient-seriour-illness" className={`${classes.storefrontMedication} ${classes.storefrontMedicationMargin}`}>
                                <span id="main-page-patient-serious-illness-label" className={classes.medBold}>Serious Illness:</span> {this.changeValueToString(selectedPatientInfo.SeriousIllness)}
                            </div>
                            <div id="main-page-patient-allergies" className={`${classes.storefrontMedication} ${classes.storefrontMedicationMargin}`}>
                                <span id="main-page-patient-allergies-label" className={classes.medBold}>Allergies:</span> {this.changeValueToString(selectedPatientInfo.Allergies)}
                            </div>
                        </div>

                    </div>
                </div>

                <div className={classes.tabHeader}>
                    <Tabs TabIndicatorProps={{ children: <div /> }} classes={{ indicator: classes.indicator, root: classes.tabsRoot }} value={selectedTab} onChange={this.handleChange} aria-label="simple tabs example">
                        <Tab classes={{ root: selectedTab === 0 ? classes.selectedTab : classes.tabStyle }} label="Consult" {...a11yProps(0)} />
                        <Tab classes={{ root: selectedTab === 1 ? classes.selectedTab : classes.tabStyle }} label="Notes" {...a11yProps(1)} />
                    </Tabs>
                </div>

                <TabPanel value={selectedTab} index={0}>
                    <ConsultTab
                        productInfo={productInfo}
                        notEditIcon
                        selectedCardData={{ OrderId: orderId }}
                        selectedPatientInfo={selectedPatientInfo} {...restProps}
                        isHistoryView={true}
                        changeProducts={{api: apiData(new Map())}}
                        addProductInfo={addProductInfo().addProductInfo}
                    />
                </TabPanel>
                <TabPanel value={selectedTab} index={1}>
                    <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
                        <div className={classes.tableWrapper}>
                            <div className={`${classes.orderDateStyle}`}>
                                <div id="consult-order-date-header" className={`${classes.tableHeaderTitle}`}>
                                    Order Date
                    </div>
                                <div className={classes.tableRowWrapper}>
                                    {tableRows.OrderDate}
                                </div>
                            </div>

                            <div className={`${classes.orderNumberStyle}`}>
                                <div id="consult-order-number-header" className={`${classes.tableHeaderTitle}`}>
                                    Order Number
                    </div>
                                <div className={classes.tableRowWrapper}>
                                    {tableRows.OrderId}
                                </div>
                            </div>

                            <div className={`${classes.productStyle}`}>
                                <div id="consult-product-header" className={`${classes.tableHeaderTitle}`}>
                                    Product
                    </div>
                                <div className={classes.tableRowWrapper}>
                                    {tableRows.ProductTitle}
                                </div>
                            </div>

                            {notEditIcon ? null : <div className={`${classes.editIconWrapper}`}>
                                <div className={`${classes.tableHeaderTitle} ${classes.iconHeader}`}>
                                    {" "}
                                </div>
                                <div className={classes.tableRowWrapper}>
                                    {tableRows.editIcon}
                                </div>
                            </div>}

                            <div className={`${classes.qty}`}>
                                <div  id="consult-qty-header" className={`${classes.tableHeaderTitle} ${classes.tableCenter}`}>
                                    Qty
                    </div>
                                <div className={classes.tableRowWrapper}>
                                    {tableRows.Qty}
                                </div>
                            </div>
                            <div className={`${classes.orderType}`}>
                                <div id="consult-order-type-header" className={`${classes.tableHeaderTitle} ${classes.tableCenter}`}>
                                    Order Type
                    </div>
                                <div className={classes.tableRowWrapper}>
                                    {tableRows.OrderType}
                                </div>
                            </div>

                            <div className={`${classes.status}`}>
                                <div id="consult-status-header" className={`${classes.tableHeaderTitle} ${classes.tableCenter} ${classes.statusStyle}`}>
                                    Status
                    </div>
                                <div className={`${classes.tableRowWrapper} ${classes.statusStyle}`}>
                                    {tableRows.Status}
                                </div>
                            </div>
                        </div>
                        <Notes historyView productInfo={productInfo} selectedCardData={{ UserId: match.params.userId }} {...restProps} />
                    </div>
                </TabPanel>

            </div>
            <ErrorModal modalOpen={errorModalOpen} closeModal={() => ToggleErrorModal(false)} />
            {loading ? <Loader /> : null}
        </div>)
    }
}

export default withStyles(MainPageStyle)(HistoryView);


class TabPanel extends React.Component {
    render() {
        let { value, index, children } = this.props;
        return (
            value === index && <div style={{ display: "flex", flex: 1, maxHeight: 500, zIndex: 0 }}>{children}</div>
        )
    }
}